import TableauEmbed from "./TableauEmbed"

export default TableauEmbed
